export default class OrientacaoDetailsController {
  constructor($q, $state, $scope, AuthenticationService, UIService, OrientacaoService, Orientacao, Orientando, GrauAcademico, Instituicao, OrientacaoTipo, OrientacaoInvestigador, OrientacaoAreaInterdisciplinar, OrientacaoEstado, Investigador, AreaInterdisciplinar) {
    this.$q = $q;
    this.$state = $state;
    this.$scope = $scope;
    this.UI = UIService;
    this.user = AuthenticationService.getUser();
    this.OrientacaoService = OrientacaoService;
    this.loaded = false;

    this.Orientacao = Orientacao;
    this.Orientando = Orientando;
    this.GrauAcademico = GrauAcademico;
    this.Instituicao = Instituicao;
    this.OrientacaoTipo = OrientacaoTipo;
    this.OrientacaoInvestigador = OrientacaoInvestigador;
    this.OrientacaoAreaInterdisciplinar = OrientacaoAreaInterdisciplinar;
    this.OrientacaoEstado = OrientacaoEstado;
    this.Investigador = Investigador;
    this.AreaInterdisciplinar = AreaInterdisciplinar;
    this.simnao = [{ name: "Sim", value: 1 }, { name: "Não", value: 0 }];
    this.showEstadosPanel = false;

    this.loaded = false;

    // Default opt state - populate later when we have all states
    this.optOrientadores = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.orientadores = null;
    this.orientadoresLoading = true;

    // Default opt state - populate later when we have all states
    this.optAreas = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.areas = null;
    this.areasLoading = true;

    this.id = $state.params.id;

    this.loadData();
    this.limit = 3;
  }

  limitTo = () => {
    if (angular.isDefined(this.limit)) {
      this.limit = undefined;
    } else {
      this.limit = 3;
    }
  };

  loadData = () => {
    this.loaded = false;
    this.Orientacao.findOne({
      filter: {
        where: {
          id: this.id
        },
        include: ['criadoPor', 'atualizadoPor', 'orientando', 'grauAcademico', 'instituicao', 'orientacaoTipo', 'estado', {
          relation: 'investigadores',
          scope: {
            include: {
              relation: 'investigador',
              scope: {
                fields: {userId: true}
              }
            }
          }
        }]
      }
    }).$promise.then(res => {
      this.data = res;

      this.getOrientadoresForOrientacao();
      this.getAreasForOrientacao();

      this.loaded = true;
    }).catch((error) => {
      console.log(error);
      this.$state.go('app.orientacao.list');
      this.UI.addToast('Erro ao carregar orientação. Verifique a ligação');
    });
  };

  editDetalhes = () => {
    let wait = this.UI.showWaiting();
    this.GrauAcademico.find({}).$promise.then(grausAcademicos => {
      this.Instituicao.find({}).$promise.then((instituicoes) => {
        this.OrientacaoTipo.find({}).$promise.then((orientacoesTipo) => {
        this.OrientacaoEstado.find({}).$promise.then((estados) => {
          wait.close();
          let options = {
            size: 'lg',
            template: require('./details.dialog.html'),
            controller: ['$scope', '$dialog', ($scope, $dialog) => {
              $scope.label = "Editar Orientação";
              $scope.orientacao = angular.copy(this.data);
              $scope.grausAcademicos = grausAcademicos;
              $scope.instituicoes = instituicoes;
              $scope.orientacoesTipo = orientacoesTipo;
              $scope.estados = estados;
              $scope.simnao = this.simnao;

              $scope.removeDate = this.UI.removeDate;
              $scope.dateOptions = {
                dataInicio: {format: 'DD/MM/YYYY'},
                dataFim: {format: 'DD/MM/YYYY'}
              };

              $scope.isValidURL = (url) => {
                if (url == null || url.length === 0) return true;
                const regex = new RegExp(
                  '^(https?:\\/\\/)?' + // protocol
                  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                  '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                  '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                  '(\\#[-a-z\\d_]*)?$', // fragment locator
                  'i'
                );
                return regex.test(url);
              };

              $scope.auxGrau = {
                selected: $scope.orientacao.grauAcademico ? $scope.orientacao.grauAcademico : null,
                infiniteScroll: {numToAdd: 20, currentItems: 20}
              };
              $scope.auxInternational = {
                selected: $scope.orientacao.orientando.international ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
                infiniteScroll: {numToAdd: 20, currentItems: 20}
              };
              $scope.auxInstituicao = {
                selected: $scope.orientacao.instituicao ? $scope.orientacao.instituicao : null,
                infiniteScroll: {numToAdd: 20, currentItems: 20}
              };
              $scope.auxTipo = {
                selected: $scope.orientacao.orientacaoTipo ? $scope.orientacao.orientacaoTipo : null,
                infiniteScroll: {numToAdd: 20, currentItems: 20}
              };
              $scope.auxEstado = {
                selected: $scope.orientacao.estado ? $scope.orientacao.estado : null,
                infiniteScroll: {numToAdd: 20, currentItems: 20}
              };

              // Infinite Scroll magic
              $scope.addMoreItems = (infiniteScroll) => {
                infiniteScroll.currentItems += infiniteScroll.numToAdd;
              };

              $scope.ok = () => {
                if (!this.OrientacaoService.isValidURL($scope.orientacao.url)) {
                  this.UI.addToast("URL Inválido");
                } else {
                  $dialog.close($scope);
                }
              };

              $scope.cancel = () => $scope.$dismiss('cancel');
            }]
          };

          this.UI.showDialog(options).then(res => {
            this.loaded = false;
            if (res) {
              this.data.dataInicio = res.orientacao.dataInicio.format();
              this.data.dataFim = res.orientacao.dataFim ? res.orientacao.dataFim.format() : null;
              this.data.titulo = res.orientacao.titulo;
              this.data.designacao = res.orientacao.designacao;
              this.data.url = res.orientacao.url || null;

              this.data.grauAcademico = res.auxGrau.selected;
              this.data.grauId = res.auxGrau.selected.id;
              this.data.instituicao = res.auxInstituicao.selected;
              this.data.instituicaoId = res.auxInstituicao.selected.id;
              this.data.orientacaoTipo = res.auxTipo.selected;
              this.data.orientacaoTipoId = res.auxTipo.selected.id;
              this.data.estado = res.auxEstado.selected;
              this.data.estadoId = res.auxEstado.selected.id;

              this.data.atualizadoPorId = this.user.id;
              this.data.atualizadoa = moment().format();

              // Specific orientando data
              this.data.orientando.nome = res.orientacao.orientando.nome;
              this.data.orientando.cartaoIdentificacao = res.orientacao.orientando.cartaoIdentificacao;
              this.data.orientando.international = res.auxInternational.selected.value;
              this.data.orientando.nomeAutor = res.orientacao.orientando.nomeAutor || null;
              this.data.orientando.email = res.orientacao.orientando.email || null;

              this.data.orientando.atualizadoPorId = this.user.id;
              this.data.orientando.atualizadoa = moment().format();

              this.Orientando.upsert(this.data.orientando).$promise.then((res) => {
                this.Orientacao.upsert(this.data).$promise.then((res) => {
                  this.UI.addToast("Dados atualizados com sucesso");
                  this.loadData();
                }).catch((error) => {
                  console.log(error);
                  this.UI.showAlert("Erro ao atualizar investigador. Verifique a ligação");
                  this.loaded = true;
                });
              }).catch((error) => {
                console.log(error);
                this.UI.showAlert("Erro ao atualizar orientando. Verifique a ligação");
                this.loaded = true;
              });
            }
          });
        }).catch((error) => {
          wait.close();
          console.log(error);
          this.UI.addToast("Não foi possível ler Estados de Orientação. Verifique a ligação");
        });
        }).catch((error) => {
          wait.close();
          console.log(error);
          this.UI.addToast("Não foi possível ler Tipos de Orientação. Verifique a ligação");
        });
      }).catch((error) => {
        wait.close();
        console.log(error);
        this.UI.addToast("Não foi possível ler Instituições. Verifique a ligação");
      });
    }).catch(error => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler Graus Académicos. Verifique a ligação");
    });
  };

  editObservacoes = () => {
    let options = {
      size: 'lg',
      template: require('./observacoes.dialog.html'),
      controller: ['$scope', ($scope) => {
        $scope.label = "Editar Observações";
        $scope.observacoes = angular.copy(this.data.observacoes);

        $scope.ok = () => {
          $scope.$close($scope);
        };

        $scope.cancel = () => $scope.$dismiss('cancel');
      }]
    };

    this.UI.showDialog(options).then(ok => {
      this.loaded = false;
      if (ok.observacoes !== 0 && !ok.observacoes)
        ok.observacoes = null;
      this.data.observacoes = ok.observacoes;

      this.data.atualizadoPorId = this.user.id;
      this.data.atualizadoa = moment().format();

      this.Orientacao.upsert(this.data).$promise.then((res) => {
        this.UI.addToast("Observações atualizadas com sucesso");
        this.loadData();
      }).catch((error) => {
        console.log(error);
        this.UI.showAlert("Erro ao atualizar revista. Verifique a ligação");
        this.loaded = true;
      });
    });
  };

  // Multiple data
  // Orientadores
  orientadoresModalOptions = (data, edit) => {
    let defer = this.$q.defer();

    let orientador = {};
    let auxInvestigadorSelection = undefined;
    if (edit && data != null) {
      orientador = angular.copy(data);
      auxInvestigadorSelection = orientador.investigador;
    }
    let wait = this.UI.showWaiting();
    this.Investigador.find({}).$promise.then((investigadores) => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      wait.close();
      defer.resolve({
        size: 'lg',
        template: require('./../new/edit.orientacao.dialog.html'),
        controller: ['$dialog', '$scope', (dialog, scope) => {
          scope.label = (edit ? "Editar" : "Novo") + " Orientador";
          scope.orientador = orientador;
          scope.investigadores = investigadores;
          scope.isInvestigador = scope.orientador.investigador !== undefined;

          scope.auxInvestigador = {
            selected: auxInvestigadorSelection,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Called just before switch is toggled, so logic is reversed
          scope.onSwitch = () => {
            if (scope.isInvestigador) { // We clicked to do Other Autor, clear selection
              scope.auxInvestigador.selected = undefined;
            } else { // We clicked to do Investigador, clear other data
              scope.orientador = {};
            }
          };

          // Infinite Scroll magic
          scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          scope.ok = () => {
            dialog.close(scope);
          };

          scope.cancel = () => {
            dialog.dismiss('cancel');
          };
        }]
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível ler investigadores. Verifique a sua ligação");
      defer.reject();
    });
    return defer.promise;
  };

  // Adicionar um novo orientador para orientação
  addOrientador = () => {
    this.orientadoresModalOptions(null, false).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInvestigador.selected) { // Adding investigador
          this.orientadoresLoading = true;
          let item = angular.copy(ok.orientador);
          item.investigadorId = ok.auxInvestigador.selected.id;
          item.investigador = angular.copy(ok.auxInvestigador.selected);
          // Check if orientador is already there before creating
          this.OrientacaoService.usedPartialDataForModel({orientacaoId: this.id, investigadorId: item.investigadorId}, this.OrientacaoInvestigador).then(res => {
            if (res.count > 0) { // Already exists
              this.UI.addToast("Orientador já existe");
              this.orientadoresLoading = false;
            } else { // Create it
              this.OrientacaoService.createMultipleData(this.OrientacaoInvestigador, [item], this.id, 'orientacaoId').then((x) => {
                this.UI.addToast("Orientador adicionado com sucesso");
                this.getOrientadoresForOrientacao();
              }).catch(error => {
                this.orientadoresLoading = false;
                this.UI.addToast("Erro ao inserir orientador. Verifique a ligação");
                console.log(error);
              });
            }
          }).catch((error) => {
            this.orientadoresLoading = false;
            this.UI.addToast("Erro de criação. Verifique a ligação.");
            console.log(error);
          });
        } else if (ok.orientador.orientador) { // Adding Orientador Externo
          this.orientadoresLoading = true;
          let item = angular.copy(ok.orientador);
          item.investigadorId = null;
          this.OrientacaoService.createMultipleData(this.OrientacaoInvestigador, [item], this.id, 'orientacaoId').then((x) => {
            this.UI.addToast("Orientador adicionado com sucesso");
            this.getOrientadoresForOrientacao();
          }).catch(error => {
            this.orientadoresLoading = false;
            this.UI.addToast("Erro ao inserir orientador. Verifique a ligação");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Ask confirmation to delete orientador
  confirmDeleteOrientador = (x) => {
    let title = "Eliminar Orientador";
    let warning = "Tem a certeza que pretende remover este orientador?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeOrientador(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeOrientador = (x) => {
    this.orientadoresLoading = true;
    // Find again orientador to delete so we can update it
    this.OrientacaoInvestigador.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((orientadorToRemove) => {
      // Only for mandatory existing multiple data
      this.OrientacaoInvestigador.count({
        fields: {id: true},
        where: {
          and: [{orientacaoId: this.id}, {investigadorId: {neq: null}}]
        }
      }).$promise.then((res) => {
        if (res.count > 1 || x.investigadorId == null) { // There are other orientadores still remaining or can just delete no problem

          // Remove data
          this.OrientacaoInvestigador.deleteById({
            id: orientadorToRemove.id,
          }).$promise.then((r) => {
            this.UI.addToast("Orientador removido com sucesso");
            this.getOrientadoresForOrientacao();
          });

        } else { // No other orientadores exist, can't remove
          this.orientadoresLoading = false;
          this.UI.showAlert("Não foi possível apagar o orientador porque tem que haver pelo menos 1 registo de investigador para a orientação");
        }
      }).catch((error) => {
        console.log(error);
        this.UI.addToast("Não foi possível consultar orientação. Verifique a ligação");
        this.getOrientadoresForOrientacao();
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar orientador. Verifique se ainda existe.");
      this.getOrientadoresForOrientacao();
    });
  };

  getOrientadoresForOrientacao = () => {
    this.orientadoresLoading = true;
    let whereLiteral = {
      'OrientacaoInvestigador.orientacaoId': this.id
    };
    let where = {};
    Object.keys(this.optOrientadores.filter).forEach(f => {
      if (this.optOrientadores.filter[f])
        where[f] = this.optOrientadores.filter[f];
    });
    this.OrientacaoInvestigador.table({
      params: {
        fields: [
          'OrientacaoInvestigador.id as id',
          'OrientacaoInvestigador.orientacaoId as orientacaoId',
          'OrientacaoInvestigador.investigadorId as investigadorId',
          'OrientacaoInvestigador.orientador as orientador',
          'OrientacaoInvestigador.dataCriacao as dataCriacao',
          'OrientacaoInvestigador.atualizadoa as atualizadoa',
          'OrientacaoInvestigador.criadoPorId as criadoPorId',
          'User.name as criadoPorName',
          'User2.name as atualizadoPorName',
          'Investigador.id as auxInvestigadorId',
          'Investigador.nome as auxInvestigadorNome'
        ],
        from: ['OrientacaoInvestigador', 'User', 'User', 'Investigador'],
        references: [undefined, 'OrientacaoInvestigador.criadoPorId', 'OrientacaoInvestigador.atualizadoPorId', 'OrientacaoInvestigador.investigadorId'],
        aliases: [null, null, 'User2', null],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optOrientadores.order,
        sort: this.optOrientadores.sort,
        limit: this.optOrientadores.items,
        skip: (this.optOrientadores.page - 1) * this.optOrientadores.items,
      }
    }).$promise.then(res => {
      let page = this.optOrientadores.page;
      let items = this.optOrientadores.items;

      let total = res.count;

      this.optOrientadores.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optOrientadores.start - 1 + items) >= total) {
        this.optOrientadores.end = total;
      } else {
        this.optOrientadores.end = Number.parseInt(this.optOrientadores.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.investigador = {
          id: x.auxInvestigadorId,
          nome: x.auxInvestigadorNome
        };
      });

      this.orientadores = res.data;
      this.optOrientadores.total = total;
      this.orientadoresLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler orientadores. Verifique a ligação");
    });
  };

  orientadorSort = keyname => {
    if (this.optOrientadores.order === keyname)
      this.optOrientadores.page = 1;
    this.optOrientadores.order = keyname;
    this.optOrientadores.sort = this.optOrientadores.sort === 'asc' ? 'desc' : 'asc';
    this.getOrientadoresForOrientacao();
  };

  orientadorItem = val => {
    this.optOrientadores.items = val;
    this.optOrientadores.page = 1;
    this.getOrientadoresForOrientacao();
  };

  orientadorPage = sum => {
    this.optOrientadores.page += sum;
    if (this.optOrientadores.page < 1)
      this.optOrientadores.page = 1;
    if (this.optOrientadores.page > Math.ceil(this.optOrientadores.total / this.optOrientadores.items))
      this.optOrientadores.page = Math.ceil(this.optOrientadores.total / this.optOrientadores.items);
    this.getOrientadoresForOrientacao();
  };

  viewOrientador = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./orientador.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).isValid() ? moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.atualizadoa = moment($scope.data.atualizadoa).isValid() ? moment($scope.data.atualizadoa).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };


  // Área Interdisciplinar
  areasModalOptions = (data, edit) => {
    let defer = this.$q.defer();

    let area = {};
    let auxAreaSelection = undefined;
    if (edit && data != null) {
      area = angular.copy(data);
      auxAreaSelection = area.area;
    }
    let wait = this.UI.showWaiting();
    this.AreaInterdisciplinar.find({}).$promise.then((areas) => {
      wait.close();
      defer.resolve({
        size: 'lg',
        template: require('./../new/edit.area.dialog.html'),
        controller: ['$dialog', '$scope', (dialog, scope) => {
          scope.label = (edit ? "Editar" : "Nova") + " Área Interdisciplinar";
          scope.area = area;
          scope.areas = areas;

          scope.auxArea = {
            selected: auxAreaSelection,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          scope.ok = () => {
            dialog.close(scope);
          };

          scope.cancel = () => {
            dialog.dismiss('cancel');
          };
        }]
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível ler áreas interdisciplinares. Verifique a sua ligação");
      defer.reject();
    });
    return defer.promise;
  };

  // Adicionar um nova área para orientação
  addArea = () => {
    if (this.areas.length >= 3) {
      this.UI.addToast("Só é possível escolher até 3 áreas");
      return;
    }
    this.areasModalOptions(null, false).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxArea && ok.area) {
          this.areasLoading = true;
          let item = angular.copy(ok.area);
          item.areaId = ok.auxArea.selected.id;
          item.area = angular.copy(ok.auxArea.selected);
          // Check if area is already there before creating
          this.OrientacaoService.usedPartialDataForModel({orientacaoId: this.id, areaId: item.areaId}, this.OrientacaoAreaInterdisciplinar).then(res => {
            if (res.count > 0) { // Already exists
              this.UI.addToast("Área Interdisciplinar já existe");
              this.areasLoading = false;
            } else { // Create it
              this.OrientacaoService.createMultipleData(this.OrientacaoAreaInterdisciplinar, [item], this.id, 'orientacaoId').then((x) => {
                this.UI.addToast("Área Interdisciplinar adicionada com sucesso");
                this.getAreasForOrientacao();
              }).catch(error => {
                this.areasLoading = false;
                this.UI.addToast("Erro ao inserir área. Verifique a ligação");
                console.log(error);
              });
            }
          }).catch((error) => {
            this.areasLoading = false;
            this.UI.addToast("Erro de criação. Verifique a ligação.");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Ask confirmation to delete entrada/saida
  confirmDeleteArea = (x) => {
    let title = "Eliminar Área Interdisciplinar";
    let warning = "Tem a certeza que pretende remover esta área interdisciplinar?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeArea(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeArea = (x) => {
    this.areasLoading = true;
    // Find again area to delete so we can update it
    this.OrientacaoAreaInterdisciplinar.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((areaToRemove) => {
      // Only for mandatory existing multiple data
      this.OrientacaoAreaInterdisciplinar.count({
        fields: {id: true},
        where: {
          orientacaoId: this.id
        }
      }).$promise.then((res) => {
        if (res.count > 1) { // There are other areas still remaining

          // Remove data
          this.OrientacaoAreaInterdisciplinar.deleteById({
            id: areaToRemove.id,
          }).$promise.then((r) => {
            this.UI.addToast("Área interdisciplinar removida com sucesso");
            this.getAreasForOrientacao();
          });

        } else { // No other areas exist, can't remove
          this.areasLoading = false;
          this.UI.showAlert("Não foi possível apagar a área interdisciplinar porque tem que haver pelo menos 1 registo para a orientação");
        }
      }).catch((error) => {
        console.log(error);
        this.UI.addToast("Não foi possível consultar orientação. Verifique a ligação");
        this.getAreasForOrientacao();
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar área interdisciplinar. Verifique se ainda existe.");
      this.getAreasForOrientacao();
    });
  };

  getAreasForOrientacao = () => {
    this.areasLoading = true;
    let whereLiteral = {
      'OrientacaoAreaInterdisciplinar.orientacaoId': this.id
    };
    let where = {};
    Object.keys(this.optAreas.filter).forEach(f => {
      if (this.optAreas.filter[f])
        where[f] = this.optAreas.filter[f];
    });
    this.OrientacaoAreaInterdisciplinar.table({
      params: {
        fields: [
          'OrientacaoAreaInterdisciplinar.id as id',
          'OrientacaoAreaInterdisciplinar.orientacaoId as orientacaoId',
          'OrientacaoAreaInterdisciplinar.areaId as areaId',
          'OrientacaoAreaInterdisciplinar.dataCriacao as dataCriacao',
          'OrientacaoAreaInterdisciplinar.atualizadoa as atualizadoa',
          'OrientacaoAreaInterdisciplinar.criadoPorId as criadoPorId',
          'User.name as criadoPorName',
          'User2.name as atualizadoPorName',
          'AreaInterdisciplinar.id as auxAreaId',
          'AreaInterdisciplinar.designacao as auxAreaDesignacao'
        ],
        from: ['OrientacaoAreaInterdisciplinar', 'User', 'User', 'AreaInterdisciplinar'],
        references: [undefined, 'OrientacaoAreaInterdisciplinar.criadoPorId', 'OrientacaoAreaInterdisciplinar.atualizadoPorId', 'OrientacaoAreaInterdisciplinar.areaId'],
        aliases: [null, null, 'User2', null],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optAreas.order,
        sort: this.optAreas.sort,
        limit: this.optAreas.items,
        skip: (this.optAreas.page - 1) * this.optAreas.items,
      }
    }).$promise.then(res => {
      let page = this.optAreas.page;
      let items = this.optAreas.items;

      let total = res.count;

      this.optAreas.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optAreas.start - 1 + items) >= total) {
        this.optAreas.end = total;
      } else {
        this.optAreas.end = Number.parseInt(this.optAreas.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.area = {
          id: x.auxAreaId,
          designacao: x.auxAreaDesignacao
        };
      });

      this.areas = res.data;
      this.optAreas.total = total;
      this.areasLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler áreas. Verifique a ligação");
    });
  };

  areaSort = keyname => {
    if (this.optAreas.order === keyname)
      this.optAreas.page = 1;
    this.optAreas.order = keyname;
    this.optAreas.sort = this.optAreas.sort === 'asc' ? 'desc' : 'asc';
    this.getAreasForOrientacao();
  };

  areaItem = val => {
    this.optAreas.items = val;
    this.optAreas.page = 1;
    this.getAreasForOrientacao();
  };

  areaPage = sum => {
    this.optAreas.page += sum;
    if (this.optAreas.page < 1)
      this.optAreas.page = 1;
    if (this.optAreas.page > Math.ceil(this.optAreas.total / this.optAreas.items))
      this.optAreas.page = Math.ceil(this.optAreas.total / this.optAreas.items);
    this.getAreasForOrientacao();
  };

  viewArea = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./area.interdisciplinar.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).isValid() ? moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.atualizadoa = moment($scope.data.atualizadoa).isValid() ? moment($scope.data.atualizadoa).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };

  // Permissions
  // read: (ownPermission, allowAll, adminPermission, users)
  // edit: (ownPermission, allowOwn, adminPermission, users)
  canReadGeneral = () => this.OrientacaoService.canRead('orientacaoRead', true, 'orientacaoReadAny', this.OrientacaoService.getInvestigadorUserId(this.data));
  canEditGeneral = () => this.OrientacaoService.canEdit('orientacaoEdit', true, 'orientacaoEditAny', this.OrientacaoService.getInvestigadorUserId(this.data));

  canReadAdicional = () => this.OrientacaoService.canRead('orientacaoReadAdicional', true, 'orientacaoReadAdicionalAny', this.OrientacaoService.getInvestigadorUserId(this.data));
  canEditAdicional = () => this.OrientacaoService.canEdit('orientacaoEditAdicional', true, 'orientacaoEditAdicionalAny', this.OrientacaoService.getInvestigadorUserId(this.data));

  canReadInvestigador = () => this.OrientacaoService.canRead('orientacaoReadInvestigador', true, 'orientacaoReadInvestigadorAny', this.OrientacaoService.getInvestigadorUserId(this.data));
  canEditInvestigador = () => this.OrientacaoService.canEdit('orientacaoEditInvestigador', true, 'orientacaoEditInvestigadorAny', this.OrientacaoService.getInvestigadorUserId(this.data));

  canReadAreaInterdisciplinar = () => this.OrientacaoService.canRead('orientacaoReadAreaInterdisciplinar', true, 'orientacaoReadAreaInterdisciplinarAny', this.OrientacaoService.getInvestigadorUserId(this.data));
  canEditAreaInterdisciplinar = () => this.OrientacaoService.canEdit('orientacaoEditAreaInterdisciplinar', true, 'orientacaoEditAreaInterdisciplinarAny', this.OrientacaoService.getInvestigadorUserId(this.data));

}

OrientacaoDetailsController.$inject = ['$q', '$state', '$scope', 'AuthenticationService', 'UIService', 'OrientacaoService', 'Orientacao', 'Orientando', 'GrauAcademico', 'Instituicao', 'OrientacaoTipo', 'OrientacaoInvestigador', 'OrientacaoAreaInterdisciplinar', 'OrientacaoEstado', 'Investigador', 'AreaInterdisciplinar'];
